var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000077314303107980171160000007811905103535594652_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000037664783464279495350000000606561795956937368_);}\r\n\t.st5{fill:#EB6E7B;}\r\n\t.st6{clip-path:url(#SVGID_00000054231278065222315630000009137568665246867850_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176745612154918106870000013348687065785427623_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176745612154918106870000013348687065785427623_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036238135939038604310000001640732192966227330_",
    x: 5.4,
    y: 6.4,
    width: 92.1,
    height: 92.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145764761423907632910000008350525012543920513_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036238135939038604310000001640732192966227330_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145764761423907632910000008350525012543920513_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.6,10.9L25.7,25.8c-0.7,0.7-1.1,1.7-1.1,2.7c0,1,0.4,2,1.1,2.7c0.7,0.7,1.7,1.1,2.7,1.1c1,0,2-0.3,2.7-1.1 l14.9-14.9c0.4-0.5,0.9-0.8,1.5-1.2c0,0,0,0.1,0,0.2l0.1,60.2c0,1,0.4,2,1.1,2.7c0.7,0.7,1.7,1.1,2.7,1.1c1,0,2-0.4,2.7-1.1 c0.7-0.7,1.1-1.7,1.1-2.7l-0.1-60.2c0-0.1-0.1-0.2-0.1-0.3c0.7,0.3,1.3,0.8,1.8,1.3l14.9,14.9c0.3,0.3,0.8,0.7,1.3,0.8 c0.5,0.2,1,0.3,1.5,0.3c0.5,0,1-0.1,1.5-0.3c0.5-0.2,0.9-0.5,1.3-0.8c0.3-0.3,0.7-0.8,0.8-1.3c0.2-0.5,0.3-1,0.3-1.5 c0-0.5-0.1-1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.3L62.4,10.9C59.5,8,55.6,6.4,51.5,6.4S43.5,8,40.6,10.9L40.6,10.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.9,71.7l0,7.7c0,3.1-1.2,6-3.4,8.1c-2.1,2.2-5.1,3.4-8.1,3.4l-53.7,0c-3.1,0-6-1.2-8.1-3.4 c-2.2-2.1-3.4-5.1-3.4-8.1l0-7.7c0-1-0.4-2-1.1-2.7c-0.7-0.7-1.7-1.1-2.7-1.1c-1,0-2,0.4-2.7,1.1c-0.7,0.7-1.1,1.7-1.1,2.7l0,7.7 c0,5.1,2,10,5.6,13.6c3.6,3.6,8.4,5.6,13.6,5.6l53.7,0c5.1,0,10-2,13.6-5.6c3.6-3.6,5.6-8.4,5.6-13.6l0-7.7c0-1-0.4-2-1.1-2.7 c-0.7-0.7-1.7-1.1-2.7-1.1c-1,0-2,0.4-2.7,1.1C90.3,69.7,89.9,70.6,89.9,71.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.289f2fcf147ec2dae39b09135380cbf1.svg";
export { ForwardRef as ReactComponent };